import PersonIcon from '@mui/icons-material/Person';
import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

import { User } from '../../providers/AuthProvider/AuthContext';

interface UserMenuProps {
  user: User;
}

export const UserMenu = ({ user }: UserMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-haspopup="true"
        onClick={handleMenu}
        sx={{ color: (theme) => theme.palette.primary.contrastText }}
        startIcon={<PersonIcon />}
      >
        {user.firstName}
      </Button>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem disabled>
          {`${user.firstName} ${user.lastName}`}
          <br />
          {user.email}
        </MenuItem>
      </Menu>
    </>
  );
};
